<template>
  <div id="app">
    <h3><img id="logo" :src="logoUrl" class="mx-auto d-block"/></h3>
    <div v-show="!complete" id="questions">
      
      <Code show="code" next="veteranRelationship"/>
      <Link show="link" next="veteranRelationship"/>

      <HIPPA 
        question="Authorization & HIPAA Consent"
        prev="link"
        show="hippa" 
        next="veteranRelationship"/>
      
      <VeteranRelationship
        show="veteranRelationship" 
        next="claimantName"
      />

      <Name
        question="What is your name?"
        prev="veteranRelationship"
        show="claimantName"
        next="claimantBirthDay"
      />

      <Birthday
        question="What is your birthday and where were you born?"
        prev="claimantName"
        show="claimantBirthDay"
        next="claimantSSN"
      />

      <SSN
        question="Identification Numbers"
        prev="claimantBirthDay"
        show="claimantSSN"
        next="claimantSex"
      />

      <Sex
        question="What is your gender?"
        prev="claimantSSN"
        show="claimantSex"
        next="claimantEmail"
      />

      <Email
        question="Email and Phone Numbers"
        prev="claimantSex"
        show="claimantEmail"
        next="claimantAddress"
      />

      <Address
        question="Mailing Address"
        prev="claimantEmail"
        show="claimantAddress"
        next="claimantEmergencyContact"
      />

      <EmergencyContact
        question="Your emergency contact"
        prev="claimantAddress"
        show="claimantEmergencyContact"
        :next="this.veteranRelationship !== 'Self' ? 'veteranName' : 'veteranBOS'"
      />

      <Name
        question="What is the veteran's name?"
        prev="claimantEmergencyContact"
        show="veteranName"
        next="veteranBirthDay"
      />

      <Birthday
        question="What is the veteran's birthday, and where were they born?"
        prev="veteranName"
        show="veteranBirthDay"
        next="veteranSSN"
      />

      <SSN
        question="Identification Numbers"
        prev="veteranBirthDay"
        show="veteranSSN"
        next="veteranSex"
      />

      <Sex
        question="What is the veteran's gender?"
        prev="veteranSSN"
        show="veteranSex"
        next="veteranDeathDay"
      />

      <DeathDay
        prev="veteranSex"
        show="veteranDeathDay"
        next="veteranEmail"
      />


      <Email
        question="Veteran's Email and Phone Numbers"
        prev="veteranDeathDay"
        show="veteranEmail"
        next="veteranAddress"
      />

      <Address
        question="Veteran's Mailing Address"
        prev="veteranEmail"
        show="veteranAddress"
        next="veteranEmergencyContact"
      />

      <EmergencyContact
        question="Veteran's emergency contact:"
        prev="veteranAddress"
        show="veteranEmergencyContact"
        next="veteranBOS"
      />

      <Service
        question="Branch of Service"
        :prev="this.veteranRelationship !== 'Self' ? 'veteranEmergencyContact' : 'claimantEmergencyContact'"
        show="veteranBOS"
        next="claimantSignature"
      />
      
      <Signature
        question="E Signature"
        prev="veteranBOS"
        show="claimantSignature"
        next="submit"
      />

      <Submit/>
    </div>
    <br>

    <div v-show="complete" class="container">
      <div class="card">
        <div class="card-header"><h1 class="text-center">Form Submission Successful!</h1></div>
        <div class="card-body">
          <h5 class="text-center" v-html="firm.intakeConfirmationMessage"></h5>
        </div>
      </div>
    </div>
    <br>
    <p class="text-center">
      <small>&copy; Pardue Computing, LLC</small>
    </p>
  </div>
</template>
<script>
import VeteranRelationship from "./components/VeteranRelationship.vue";
import Name from "./components/Person/Name.vue";
import Birthday from "./components/Person/Birthday.vue";
import SSN from "./components/Person/SSN.vue";
import Sex from "./components/Person/Sex.vue";
import Email from "./components/Person/Email.vue";
import Address from "./components/Person/Address.vue";
import EmergencyContact from "./components/Person/EmergencyContact.vue";
import Service from "./components/Person/Service.vue";
import DeathDay from "./components/Person/DeathDay.vue";
import Signature from './components/Signature.vue'


import Submit from "./components/Submit.vue";
import Code from "./components/Code.vue";
import Link from "./components/Link.vue";
import HIPPA from "./components/Person/HIPPA.vue";

let url = new URL(window.location.href);
var code = url.searchParams.get("code");
let link = url.searchParams.get("link");
let firmId = url.searchParams.get("firmId");

window.onbeforeunload = function() {
  return false;
};

export default {
  name: "App",
  components: {
    VeteranRelationship,
    Signature,
    Name,
    Birthday,
    SSN,
    Sex,
    Email,
    Address,
    EmergencyContact,
    Service,
    Submit,
    DeathDay,
    Code,
    Link,
    HIPPA
},
  async created() {
    this.$on("veteranRelationshipChanged", function(to) {
      if (to !== undefined) {
        this.$data.veteranRelationship = to;
      }
    });

    this.$on("savePerson", function() {
      this.postData();
    });

    this.$on("setCurrentQuestion", function(next) {
      this.$data.currentQuestion = next;
    });
    
    this.$on("gotCode", function(code) {
      this.$data.currentQuestion = "veteranRelationship";
      this.$data.code = code;
    });
    let myObject = await fetch("../../../vch/firm?id="+firmId); //remove vch to test
    let firm = await myObject.json();
    document.title = firm.customTitle;
    this.firm = firm;
  },
  methods: {
    getInitialQuestion() {
      if (code !== null) {
        return "veteranRelationship";
      } else if (link !== null) {
        return "link";
      } else {
        return "code";
      }
    }
  },
  data: function() {
    return {
      veteranRelationship: "",
      currentQuestion: this.getInitialQuestion(),
      complete: false,
      dev: false,
      code: code,
      logoUrl: "logo-"+(link ? link: firmId)+".png",
      firm: {"intakeConfirmationMessage": ""},
      firmId: firmId
    };
  }
};
</script>
<style>
#questions {
  margin-top: 10px;
}
#logo {
  width: 25%;
  height: auto;
  margin-top: 10px;
}
.btn-primary {
    color: #fff;
    background-color: #262d6b;
    border-color: #262d6b;
}
h1 { 
  color: #C22032
}
</style>
